import { find, get } from 'lodash';
import Divider from 'material-ui/Divider';
import * as React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { branch, compose, lifecycle, renderComponent, withHandlers, withProps, withStateHandlers } from 'recompose';

import { InlineGrid, InlineGridField } from '@components/form';
import { withNotifications } from '@components/hoc/withNotifications';

import { Loader } from '@components/loader';
import { ActionBar } from '@modules/events/EventsFormRecordServicesActionbar';
import { recordGridColumns } from '@modules/events/_eventsColumns';
import { cancelDocument, getDocumentsFromEventId, getRecordFromEventId } from '@modules/records/_recordsActions';
import { addPragueTz } from '@utils/timezone';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { EventsFormRecordServicesForm } from './EventsFormRecordServicesForm';

const formName = 'module-records';

const mapStateToProps = state => ({
  files: get(state, 'form.module-events.values.files', []),
  photos: get(state, 'form.module-events.values.photos', []),
  eventId: get(state, 'form.module-events.values.id', null),
  documents: get(state, `form.${formName}.values.documents`, [])
});

const enhance = compose<any, any>(
  withNotifications({
    getRecordFromEventId,
    getDocumentsFromEventId
  }),
  connect(mapStateToProps),
  withStateHandlers(
    {
      loader: 0,
      initialLoading: true,
      record: null,
      initialValues: {},
      checkedDocuments: []
    },
    {
      setLoader: ({ loader }) => handleLoader => handleLoader(loader),
      setState: oldState => newState => ({ ...oldState, ...newState })
    }
  ),
  withHandlers({
    onRefresh: ({
      eventId,
      setLoader,
      setState,
      getRecordFromEventIdNotify,
      getDocumentsFromEventIdNotify,
      reloadEvent
    }) => async () => {
      setLoader(i => ++i);
      const [record, documents] = await Promise.all([
        getRecordFromEventIdNotify(eventId),
        getDocumentsFromEventIdNotify(eventId),
        reloadEvent()
      ]);

      setState({ record, initialValues: { documents }, initialLoading: false });
      setLoader(i => --i);
    },
    onCheckedDocumentsChange: ({ setState }) => checkedDocuments => setState({ checkedDocuments }),
    rowStyleFn: ({ files }) => item => {
      let fileDeleted = false;
      let fileUpdated = false;
      if (item && item.attachments) {
        item.attachments.forEach(a => {
          const file = files.find(f => f.id === a.file.id);
          if (!file) {
            fileDeleted = true;
          }
          const syncDate = new Date(a.syncDatetime);
          if (file && new Date(file.updated) > addPragueTz(syncDate)) {
            fileUpdated = true;
          }
        });
      }
      if (fileDeleted) {
        return { backgroundColor: '#ffd4d4' };
      }
      if (fileUpdated) {
        return { backgroundColor: '#9393ff' };
      }
      return null;
    }
  }),
  lifecycle<any, any>({
    async componentDidMount() {
      const { onRefresh } = this.props;
      onRefresh();
    },
    componentDidUpdate(prevProps: any) {
      const { activeTab, onRefresh } = this.props;
      if (activeTab !== prevProps.activeTab && activeTab === 'recordServices') {
        onRefresh();
      }
    }
  }),
  branch(({ initialLoading }) => initialLoading, renderComponent(Loader)),
  reduxForm({ form: formName, enableReinitialize: true })
);

const View: React.SFC<any> = ({
  disabled,
  record,
  sps,
  files,
  photos,
  eventId,
  onRefresh,
  documents,
  setState,
  checkedDocuments,
  onCheckedDocumentsChange,
  rowStyleFn
}) => {
  // true => locked document found
  const isDisabled = !!find(documents, d => d.record && d.record.lock);

  const DocumentsForm = React.useMemo(
    () => {
      return withProps({
        sps,
        files,
        photos,
        eventId,
        onRefresh,
        setState,
        disabled: isDisabled
      })(EventsFormRecordServicesForm);
    },
    [sps, files, eventId, onRefresh, setState, isDisabled]
  );

  return (
    <div>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <h4>Spisová služba</h4>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <InlineGridField
              component={InlineGrid}
              name="documents"
              Form={DocumentsForm}
              ActionBar={withProps({
                record,
                documents,
                eventId,
                setState,
                onRefresh,
                checkedDocuments,
                files,
                photos,
                sps,
                isDisabled
              })(ActionBar)}
              gridProps={{ addLabel: 'Přidat dokument', version: 2 }}
              columns={recordGridColumns}
              showCheckboxes={true}
              adding={!disabled && !isDisabled}
              editing={!disabled}
              deleting={!disabled}
              onDelete={async items => {
                for (const item of items) {
                  await cancelDocument(item.id);
                }
              }}
              addLabel="Přidat dokument"
              onCheckedItemsChange={onCheckedDocumentsChange}
              rowStyleFn={rowStyleFn}
            />
          </Col>
        </Row>
      </Grid>

      <Divider />
    </div>
  );
};

export const WithoutId = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Spisová služba</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <h4>Pro práci se spisovou službou uložte událost</h4>
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormRecordServices.tsx